import getLocalString from "constants/Localization";
import { useSendOrganizationEmailIdentityTestEmailMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import { useCallback } from "react";

export default function useSendOrganizationEmailIdentityTestEmail() {
  const [mutation, { data, loading, error }] = useSendOrganizationEmailIdentityTestEmailMutation();

  const [sendTestEmail, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "sendOrganizationEmailIdentityTestEmail",
    },
    {
      successMessage: getLocalString("emailIdentity.send-test-email-success"),
      failureMessage: getLocalString("emailIdentity.send-test-email-failure"),
    }
  );

  const handleSendTestEmail = useCallback(async () => {
    await sendTestEmail({});
  }, [sendTestEmail]);

  return [handleSendTestEmail, context] as const;
}
